
/**
 * 日志工具
 */
module.exports = function() {
	// arguments 接收不定参数
	if (console && console.log) {
		console.log(arguments);
		
	} else {
		
		
	}
	
	
};


//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/support/logger.js
// module id = 12
// module chunks = 0